import { useRef } from "react";

import { handleTitleChange } from "@/assignments/utils/assignmentActions";
import { getIsSavedAssignment } from "@/assignments/utils/assignmentUrlHelpers";
import { Assignment } from "@/types/models";
import { UserProperties } from "@/types/models/UserProperties.interface";
import AssignmentInstructionsInput from "@/view/ActivityPanel/AssignmentInstructionsInput";
import AssignmentTitleInput from "@/view/ActivityPanel/AssignmentTitleInput";
import AssignmentOptions from "@/view/AssignModal/AssignmentOptions";
import { GenerationGeniusContent } from "@/view/GeniusContent/GeniusContent.interface";
import ScheduledInput from "@/view/ScheduledInput/ScheduledInput";
import GeniusActivityPanel from "./GeniusActivityPanel";

interface GeniusAssignModalInputsProps {
  assignmentRequest: { loading: boolean };
  content: GenerationGeniusContent;
  dispatch: () => void;
  handleSaveDraft: () => Promise<any>;
  hasAssigneeError: boolean;
  resetDate: string | null;
  selectedAssignmentId: string | string[] | undefined;
  setHasAssigneeError: (hasError: boolean) => void;
  updatedAssignment: Assignment;
  userProperties: UserProperties;
}

const GeniusAssignModalInputs = ({
  assignmentRequest: { loading: isSelectedAssignmentLoading },
  content,
  dispatch,
  handleSaveDraft,
  hasAssigneeError,
  resetDate,
  selectedAssignmentId,
  setHasAssigneeError,
  updatedAssignment,
  userProperties,
}: GeniusAssignModalInputsProps) => {
  const isSavedAssignment = getIsSavedAssignment(selectedAssignmentId);
  // Form unsaved state
  const initialAssignmentRef = useRef<Assignment | null>(null);
  const setInitialAssignmentRef = (
    initialUpdatedAssignmentOnMount: Assignment,
  ) => {
    initialAssignmentRef.current = initialUpdatedAssignmentOnMount;
  };

  return (
    <>
      <AssignmentTitleInput
        dispatch={dispatch}
        handleSetInitialAssignmentRef={setInitialAssignmentRef}
        handleTitleChange={handleTitleChange}
        isSavedAssignment={isSavedAssignment}
        isLoading={isSelectedAssignmentLoading}
        updatedAssignment={updatedAssignment}
        initialTitle={content.data.title}
      />
      <AssignmentInstructionsInput isEditorOpen />
      <AssignmentOptions
        assignment={updatedAssignment as Assignment}
        contentId={content.id}
        dispatch={dispatch}
        hasError={hasAssigneeError}
        dismissAssigneeError={() => setHasAssigneeError(false)}
        handleSaveDraft={handleSaveDraft}
      />

      <GeniusActivityPanel assignment={updatedAssignment} dispatch={dispatch} />

      <ScheduledInput
        assignment={updatedAssignment}
        content={{
          ...content,
          is_lite: content.data.is_lite,
          data: {
            ...content.data,
            article_levels: [],
          },
        }}
        userProperties={userProperties}
        dispatch={dispatch}
        resetDate={resetDate}
      />
    </>
  );
};

export default GeniusAssignModalInputs;
